export default "__VITE_ASSET__BMmbm5Iq__"